import React from 'react';

import * as cmWEB from './_cmWEB';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import { a } from './_csAbt';
import * as gs from './_csGbl';
import { useLdrz } from './_csLdr';
import { useMsgz } from './_csMdlMsg';

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

let $id = '';
let $code = '';

export const N = React.memo((pz: { // send code
  cz: {
    ccd?: ht.s,
    pfx?: ht.s,
    atrCfm: (_10rz: ht.dz) => void,
  }
}) => {

  const _pfx = pz.cz.pfx ?? '確認コード';

  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();

  React.useEffect(() => {
    $id = cmWEB.getPmrz('id') ?? '';
//hf.l(`ccmLgnNbrC 38: ${$id}`)
  }, [
  ])

  const _lgn = async () => {
    _sLdrz.show();
    const _b = await hf.ectSrlAsync([
      async () => {
        let _b = true;
        if (
          !hf.f($code)
        ) _b = false;
        if (!_b) {
          _sMsgz.show({
            textCz: {
              textz: {
                pfx: `${_pfx}を入力してください`
              }
            }
          })
        }
        return _b;
      },
    ]);
    if (_b) {
      const _dz = await f.cfmNbrAsync({
        id: $id,
        code: $code,
      });
      //hf.l(`LgnId 43: ${hf.s($id)}, ${hf.s($code)}, ${hf.s(_dz)}`);
      if (_dz.err) {
        _sMsgz.show({
          textCz: {
            textz: {
              pfx: '認証に失敗しました',
            }
          }
        })
        _sLdrz.hide();
      }
      else {
        _sLdrz.hide();
        $id = ''; $code = ''; // logout 時を考慮し初期化
        pz.cz.atrCfm(_dz.nbr);
      }
    }
    else {
      _sLdrz.hide();
    }
  }

//hf.l(`ccmLgnNbrC 89: here`)
  return (
    cr.c(BoxC.N, {
      key: `LgnID.N`,
      boxStlz: a('dw/f'),
      oClds: [

        cr.c(LblC.N, {
          key: -20,
          abtType: 'vclStfz',
          boxStlz: a('mb/3'),
          lblCz: {
            textz: {
              pfx: _pfx,
              stlz: a(`tc/${pz.cz.ccd ?? 'lt9'}`),
            },
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                cz: {
                  bEdit: true,
                  bDrt: true,
                  bScr: true,
                  iptType: 'text',
                  vle: $code,
                  onChg: (_s: ht.s) => {
                    $code = _s;
                  }
                }
              })
            ],
          }
        }),

        cr.c(BtnC.N, {
          key: -30,
          abtType: 'nextCmnz',
          boxStlz: a(`sc/${pz.cz.ccd ?? 'lt9'}`),
          lblCz: {
            textz: {
              pfx: '送る',
            }
          },
          pslPtyz: {
            onPress: _lgn,
          }
        }),

      ]
    })
  );
});
